(function () {
  document.querySelectorAll('[data-sv-collection-grid]').forEach(function (grid) {
    var itemsContainer = grid.querySelector('[data-sv-collection-grid-items]');
    var button = grid.querySelector('[data-sv-load-more]');
    var sectionId = grid.getAttribute('data-section-id');

    if (!button) return;

    button.addEventListener('click', function () {
      var nextUrl = button.getAttribute('data-next-url');
      if (!nextUrl) return;

      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Loading…';

      var separator = nextUrl.indexOf('?') > -1 ? '&' : '?';
      var url = nextUrl + separator + 'section_id=' + sectionId;

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshItems = doc.querySelector('[data-sv-collection-grid-items]');
          var freshButton = doc.querySelector('[data-sv-load-more]');

          if (freshItems) {
            Array.prototype.slice.call(freshItems.children).forEach(function (card) {
              itemsContainer.appendChild(card);
            });
          }

          if (freshButton) {
            button.setAttribute('data-next-url', freshButton.getAttribute('data-next-url'));
            button.disabled = false;
            button.textContent = originalText;
          } else {
            button.closest('.sv-collection-grid__load-more').remove();
          }
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = originalText;
        });
    });
  });
})();
